/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { DeviceCommand } from './deviceCommand';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CustomerCommandDto { 
    idCommand?: string;
    creator?: string;
    idDevice?: number;
    deviceClassWithOwnIdPool?: CustomerCommandDto.DeviceClassWithOwnIdPoolEnum;
    originCode?: CustomerCommandDto.OriginCodeEnum;
    sendToDeviceTime?: string;
    receivedResponseTime?: string;
    parameterDataList?: Array<ParameterData>;
    schedules?: Array<Schedule>;
    deviceCommand?: DeviceCommand;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    deviceResponses?: Array<CustomerCommandDto.DeviceResponsesEnum>;
    commandState?: CustomerCommandDto.CommandStateEnum;
    initialCommand?: boolean;
    remoteSendAttempts?: number;
    remoteLastSendAttempt?: string;
    appliedOnDeviceTime?: string;
    readoutCommand?: boolean;
    insertTs?: string;
}
export namespace CustomerCommandDto {
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
    export const DeviceResponsesEnum = {
        Ok: 'OK',
        VasInvalidParameter: 'VAS_INVALID_PARAMETER',
        CrcError: 'CRC_ERROR',
        SubpaketInvalid: 'SUBPAKET_INVALID',
        SubpaketNotSupported: 'SUBPAKET_NOT_SUPPORTED'
    } as const;
    export type DeviceResponsesEnum = typeof DeviceResponsesEnum[keyof typeof DeviceResponsesEnum];
    export const CommandStateEnum = {
        Created: 'CREATED',
        SentToServer: 'SENT_TO_SERVER',
        SentToDevice: 'SENT_TO_DEVICE',
        FailedSendingToServer: 'FAILED_SENDING_TO_SERVER',
        FailedSendingToDevice: 'FAILED_SENDING_TO_DEVICE',
        FailedOnDevice: 'FAILED_ON_DEVICE',
        FailedUnspecified: 'FAILED_UNSPECIFIED',
        Acknowledged: 'ACKNOWLEDGED',
        Canceled: 'CANCELED',
        FailedExpired: 'FAILED_EXPIRED'
    } as const;
    export type CommandStateEnum = typeof CommandStateEnum[keyof typeof CommandStateEnum];
}


export type DeviceClassWithOwnIdPoolEnum = typeof CustomerCommandDto.DeviceClassWithOwnIdPoolEnum[keyof typeof CustomerCommandDto.DeviceClassWithOwnIdPoolEnum];
export type DeviceResponsesEnum = typeof CustomerCommandDto.DeviceResponsesEnum[keyof typeof CustomerCommandDto.DeviceResponsesEnum];
export type CommandStateEnum = typeof CustomerCommandDto.CommandStateEnum[keyof typeof CustomerCommandDto.CommandStateEnum];
